import type {DeliveryProgressStep} from '../../../../types';

import {cn} from '@ds/helpers';

type MultiStepProgressBarProps = {
  currentStep: DeliveryProgressStep | null;
  steps: DeliveryProgressStep[];
};

const MultiStepProgressBar: React.FC<MultiStepProgressBarProps> = ({currentStep, steps}) => {
  const mainSteps = steps.filter((step) => step.type === 'main');

  if (mainSteps.length === 0) {
    return null;
  }

  const percentage = currentStep?.percentage ?? 0;

  return (
    <div className="relative my-5 h-1.25 w-full">
      <div className="absolute inset-x-5.25 top-0 h-1.25 rounded-xl bg-orange-tangerine">
        <div className="absolute inset-0 overflow-hidden rounded-xl">
          <div
            className="absolute top-0 right-0 bottom-0 bg-white transition-[width] duration-300 ease-in-out"
            style={{width: `${percentage}%`}}
          />
        </div>

        {mainSteps.map((step, index) => {
          const position =
            mainSteps.length > 1 ? (index / (mainSteps.length - 1)) * 100 : percentage;
          const accomplished = position <= percentage;

          return (
            <div
              key={`${step.status}-${index}`}
              className="absolute top-1/2 z-10 translate-x-1/2 -translate-y-1/2"
              style={{right: `${position}%`}}
            >
              <div
                className={cn(
                  'flex size-10.5 items-center justify-center rounded-full bg-orange-tangerine',
                  accomplished && 'bg-white [&_img]:brightness-0 [&_img]:grayscale'
                )}
              >
                {step.iconSrc ? (
                  <img src={step.iconSrc} alt="" className="size-5" aria-hidden />
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MultiStepProgressBar;
